<template>
  <app-tag v-model="value"
           :disabled="filter.disabled"
  >
    <span v-html="getTextFromHtmlString(filter.name)"></span>
  </app-tag>
</template>

<script>
import filterMixin from "@/mixins/filter";
import AppTag from "@/components/common/AppTag/AppTag";
import getTextFromHtmlString from "@/helpers/getTextFromHtmlString";

export default {
  name: "TagsSelectorItem",
  mixins: [filterMixin],
  components: {
    AppTag
  },
  methods: {
    getTextFromHtmlString
  }
}
</script>
